export const NAMESPACE = {
  dataType: 'data-type',
  dataValue: 'data-value',
  dataLpuAddrId: 'data-lpu-addr-id',

  prgSelector: 'form[action]',

  selectorSelectOption: '.b-select__option',

  scheduleWrapperDocList: 'b-doctor-card__wp-schedule-wrapper',
  scheduleWrapperDocItem: 'b-doctor-contacts__wp-schedule-wrapper',
  scheduleWrapperDocListHidden: 'b-doctor-card__wp-schedule-wrapper_hidden',
  scheduleWrapperDocItemHidden: 'b-doctor-contacts__wp-schedule-wrapper_hidden',
}

export const DOCTOR_PAGE_TYPE_DATA = {
  list: 'doctor-list',
  inner: 'doctor-inner', // TODO: такой тип больше не используется, удалить связанные проверки
}
